<template>
  <v-card flat>
    <v-row no-gutters no-wrap class="d-none d-sm-flex">
      <v-col>
        <!-- COMPONENTE DE FORMULARIO DE BUSCA PROCESSUAL -->
        <form-processual
          @search="filtrarBusca"
          :filtrosFormulario="filtrosFormulario"
        />
        <!-- COMPONENTE DE RESULTADO DA PESQUISA REALIZADA -->
        <resultado-busca-processual
          :resultadoBusca="resultado"
          :loading="loading"
          :termo="termoPesquisado"
          :novaBusca="novaBusca"
          :totalRegistros="totalRegistros"
          :tempoExecucao="tempoExecucao"
          @paginar="nextPage"
        />
      </v-col>
      <v-col cols="3" class="py-3 px-3">
        <!-- COMPONENTE DE HISTORICO DA PESQUISA REALIZADA -->
        <historico-pesquisa
          :listaHistorico="newHistorico"
          :resultsMobile="resultsMobile"
          :tipo="'historicoBuscaProcessual'"
          @search="filtrarHistorico"
        />
        <!-- COMPONENTE DE FILTROS DA PESQUISA REALIZADA -->
        <filtros-resultado-busca
          :termoPesquisado="termoPesquisado"
          :filtrosFormulario="filtrosFormulario"
          :filtrosBusca="filtros"
          :resultsMobile="resultsMobile"
          @filtrar="filtrarBusca"
        />
      </v-col>
    </v-row>
    <v-row class="d-flex d-sm-none">
      <v-col>
        <form-processual
          @search="filtrarBusca"
          :filtrosFormulario="filtrosFormulario"
          :isMobile="true"
        />
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          persistent
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>PROCESSUAL</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark icon text @click="drawer = !drawer">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card flat>
              <resultado-busca-processual
                :resultadoBusca="resultado"
                :loading="loading"
                :resultsMobile="resultsMobile"
                :termo="termoPesquisado"
                :novaBusca="novaBusca"
                :totalRegistros="totalRegistros"
                :tempoExecucao="tempoExecucao"
                :isMobile="true"
                @paginar="nextPage"
              />
            </v-card>
            <v-navigation-drawer width="300" v-model="drawer" fixed right>
              <historico-pesquisa
                :listaHistorico="historicoBuscaProcessual"
                :isMobile="true"
                :tipo="'historicoBuscaProcessual'"
                @search="filtrarHistorico"
              />
              <filtros-resultado-busca
                :termoPesquisado="termoPesquisado"
                :filtrosFormulario="filtrosFormulario"
                :tipo="drillFilterTipo"
                :filtrosBusca="filtros"
                :isMobile="true"
                @filtrar="filtrarBusca"
              />
            </v-navigation-drawer>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import Vue from "vue";
import HistoricoPesquisa from "@/shared/HistoricoPesquisa";
import FiltrosResultadoBusca from "@/shared/processual/FiltrosResultadoBuscaProcessual";
import ResultadoBuscaProcessual from "@/shared/processual/ResultadoBuscaProcessual";
import FormProcessual from "@/shared/processual/FormProcessual";
import moment from "moment";
export default {
  props: { historicoBuscaProcessual: {}, paramsProcessual: Array },
  components: {
    HistoricoPesquisa,
    FiltrosResultadoBusca,
    ResultadoBuscaProcessual,
    FormProcessual
  },
  data() {
    return {
      dialog: false,
      resultsMobile: false,
      drawer: false,
      filtros: {},
      filtrosFormulario: {
        relevancia: "",
        tipo: ""
      },
      drillDownFilter: {
        tipo: "",
        ano: ""
      },
      drillFilterTipo: "",
      drillFilterAno: "",
      drillFilterRelevancia: "",
      resultado: [],
      historico: [],
      loading: false,
      termoPesquisado: null,
      pageNo: 0,
      maxPerPage: 25,
      novaBusca: true,
      totalRegistros: 0,
      tempoExecucao: 0,
      newHistorico: this.historicoBuscaProcessual
    };
  },
  created() {
    if (this.historicoBuscaProcessual.length) {
      this.filtrarHistorico(this.historicoBuscaProcessual[0]);
    }
    if (this.paramsProcessual.length == 3) {
      const item = {
        termo: this.paramsProcessual[2]
      };
      this.filtrarBusca(item);
    }
  },
  methods: {
    filtrarHistorico(item) {
      item.historico = true;
      this.filtrarBusca(item);
    },
    filtrarBusca(item) {
      this.filtrosFormulario = item;
      this.novaBusca = true;
      this.pageNo = 0;
      this.maxPerPage = 25;

      this.drillDownFilter.relevancia = item.relevancia;

      if (item.termo) {
        this.termoPesquisado = item.termo;
      }

      if (item.tipo) {
        this.drillDownFilter.tipo = `&filter[Tipo][Tipo]=${item.tipo}`;
      } else {
        this.drillDownFilter.tipo = "";
      }

      if (item.ano) {
        this.drillDownFilter.ano = `&filter[Ano][Ano]=${item.ano}`;
      } else {
        this.drillDownFilter.ano = "";
      }

      this.search(item, item.historico, this.drillDownFilter);
    },
    search(form, salvaHistorico, filtroBusca) {
      this.resultado = [];
      this.filtros = {};

      if (typeof filtroBusca == "object" && filtroBusca.relevancia) {
        this.drillFilterRelevancia = filtroBusca.relevancia;
      } else {
        this.drillFilterRelevancia = "";
      }

      if (typeof filtroBusca == "object" && filtroBusca.tipo) {
        this.drillFilterTipo = filtroBusca.tipo;
      } else {
        this.drillFilterTipo = "";
      }

      if (typeof filtroBusca == "object" && filtroBusca.ano) {
        this.drillFilterAno = filtroBusca.ano;
      } else {
        this.drillFilterAno = "";
      }

      this.loading = true;

      Vue.axios({
        method: "get",
        url:
          process.env.VUE_APP_URL +
          "/publica/?q=" +
          this.termoPesquisado +
          "&from=" +
          this.pageNo +
          "&maxPerPage=" +
          this.maxPerPage +
          this.drillFilterRelevancia +
          this.drillFilterTipo +
          this.drillFilterAno,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        Vue.axios({
          method: "get",
          url:
            process.env.VUE_APP_URL +
            "/publica/tipos?q=" +
            this.termoPesquisado +
            this.drillFilterRelevancia +
            this.drillFilterTipo +
            this.drillFilterAno,
          headers: {
            "Content-Type": "application/json"
          }
        }).then(responseFiltros => {
          this.resultado = response.data.data.hits.hits;
          this.totalRegistros = response.data.data.hits.total.value;
          this.tempoExecucao = response.data.data.took;
          this.filtros = responseFiltros.data.data.aggregations;
          this.loading = false;

          if (form.isMobile) {
            this.resultsMobile = true;
            this.dialog = true;
            this.drawer = true;
          }

          if (!salvaHistorico) {
            let relevanciaText = "MAIS RELEVANTES";
            if (form.relevancia == "&sort=data_sessao&order=asc") {
              relevanciaText = "MAIS ANTIGOS";
            } else if (form.relevancia == "&sort=data_sessao&order=desc") {
              relevanciaText = "MAIS RECENTES";
            }

            const historico = {
              termo: form.termo,
              tipo: form.tipo,
              ano: form.ano,
              relevancia: form.relevancia,
              relevanciaText: relevanciaText,
              resultados: response.data.data.hits.total.value,
              dataPesquisa: moment().format("DD/MM/YYYY hh:mm:ss")
            };
            this.salvarHistorico(historico);
          }
        });
      });
    },
    nextPage($scrolling) {
      this.loading = true;
      this.novaBusca = false;
      this.pageNo = this.pageNo + 1;
      let url =
        process.env.VUE_APP_URL +
        "/publica/?q=" +
        this.termoPesquisado +
        "&from=" +
        this.pageNo * this.maxPerPage +
        "&maxPerPage=" +
        this.maxPerPage +
        this.drillFilterTipo +
        this.drillFilterAno;
      // this.getFilter();
      // let url = 'http://10.9.22.23:8001/teste/?q=' + this.search.termo +'&from=' + this.pageNo * this.maxPerPage + '&maxPerPage=' + this.maxPerPage + this.getFilter();
      Vue.axios.get(url).then(response => {
        this.loading = false;
        this.resultado = this.resultado.concat(response.data.data.hits.hits);
        if (response.data.data.hits.hits.length === this.maxPerPage) {
          $scrolling.loaded();
        } else {
          $scrolling.complete();
        }
      });
    },
    salvarHistorico(historico) {
      let lista_historico = JSON.parse(
        Vue.localStorage.get("historicoBuscaProcessual") || "[]"
      );

      lista_historico.unshift(historico);

      Vue.localStorage.set(
        "historicoBuscaProcessual",
        JSON.stringify(lista_historico)
      );
      this.newHistorico = lista_historico;
    }
  }
};
</script>
